export const Languages = Object.freeze([
    { id: "nl", name: "Nederlands" },
    { id: "en", name: "English" },
    { id: "es", name: "Español" },
    { id: "ca", name: "Català" },
]);
